/* =====================================================================================================================
   batida-konto.js: "Moje konto", the B2C customer panel, phase 1 (sections/batida-konto.liquid; Aleksandra's proposal
   "Batida_moje_konto_propozycja_3", her decisions of 29.09). batida.pl only.
   Data (nothing invented - a block without real data is hidden):
     - [data-v7k-data]  the signed-in customer, printed by Liquid: first name, e-mail marketing consent, Essential Loyalty
                        points + tier (customer metafield essential_loyalty.landing_page), addresses, last 20 orders with
                        their date attributes (Pickup-/Delivery-/Shipping-Date, -Time, Checkout-Method,
                        Pickup-Location-Company, Koszulka-Wysylka), the FoodSoft FINISH tag and a reorder plan per line
                        (snippets/batida-konto-line.liquid).
     - [data-v7k-club]  Essential Loyalty's tiers and rewards (shop metafield essential_loyalty.landing_page).
     - Batida Connect   GET /apps/connect/konto (app proxy, signed customer): saved invoice NIPs + "always invoice",
                        important dates, newsletter switch. 404 / 5xx / enabled:false = those blocks stay hidden.
                        Writes: PUT /konto/profile, POST /konto/dates, DELETE /konto/dates/<id>, PUT /konto/newsletter.
     - Batida Connect   public availability (delivery, 24 h products, closed days) for the "Zamów na jutro" countdown
                        and the nearest boutique of each address (same API the cart widget uses).
     - Ministry of Finance VAT register (wl-api.mf.gov.pl) for the company details of a NIP - the same lookup the cart's
       "Faktura na firmę" uses (assets/batida-nip-autofill.js).
   Texts: every string is a section setting (Polish default, English through Translate & Adapt); [data-v7k-t].
   Review mode: ?kontodemo=1 on an unpublished theme only (Shopify.theme.role) = sample data + banner, nothing is saved;
   "Zamów ponownie" still adds the sample orders' real products to the cart. ?kontodemo=0 ends it.
   ===================================================================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-v7k]');
  if (!root || root.__v7k) return;
  root.__v7k = true;

  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return [].slice.call((el || root).querySelectorAll(s)); }
  function readJSON(sel) { var el = root.querySelector(sel); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function pad(n) { n = String(n); return n.length < 2 ? '0' + n : n; }

  var T = readJSON('[data-v7k-t]') || {};
  var IC = readJSON('[data-v7k-icons]') || {};
  var CLUB = readJSON('[data-v7k-club]') || { on: false, tiers: [], rewards: [] };
  var REAL = readJSON('[data-v7k-data]');
  var DEMO_LINES = readJSON('[data-v7k-demo]');
  var LANG = (root.getAttribute('data-lang') || 'pl').slice(0, 2);
  var LOCALE = LANG === 'pl' ? 'pl-PL' : 'en-GB';
  var ROOT = (root.getAttribute('data-root') || '/').replace(/\/?$/, '/');
  var CONNECT = '/apps/connect/'; // fallback only: snippets/batida-connect-switch sets window.BatidaConnect.api from settings.connect_api_url
  var app = $('[data-v7k-app]');

  /* ---------- review mode (unpublished theme only) ---------- */
  var params = new URLSearchParams(location.search);
  var role = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '';
  var previewable = (!!role && role !== 'main') || /shopifypreview\.com$/.test(location.hostname);
  var KEY_DEMO = 'v7k-demo';
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }
  if (previewable && params.has('kontodemo')) sset(KEY_DEMO, params.get('kontodemo') === '1' ? '1' : null);
  var DEMO = !!(previewable && DEMO_LINES && sget(KEY_DEMO) === '1');
  if (!REAL && !DEMO) {
    /* guests: the Liquid intro + "Zaloguj się" stays as it is. A signed-in customer whose data didn't arrive (should not
       happen) gets an honest line and the way to Shopify's own account pages instead of an empty page. */
    if (root.hasAttribute('data-customer') && app) {
      var T0 = readJSON('[data-v7k-t]') || {};
      app.innerHTML = '<p class="v7k-sub">' + esc(T0.err_generic || '') + ' <a class="v7k-link" href="' + esc(root.getAttribute('data-account') || '/account') + '">' + esc(T0.acc_title || '') + '</a></p>';
      app.hidden = false;
    }
    return;
  }

  /* ---------- texts ---------- */
  function raw(k) { return T[k] == null ? '' : String(T[k]); }
  /* the text of setting k, escaped, with {placeholders} replaced by the given HTML (callers escape their values) */
  function tx(k, vars) {
    return esc(raw(k)).replace(/\{(\w+)\}/g, function (m, n) { return vars && vars[n] != null ? vars[n] : ''; });
  }
  function list(k) { return raw(k).split(',').map(function (x) { return x.trim(); }); }
  var DAYS = list('days_short'), MONTHS = list('months_gen'), MONTHS_S = list('months_short'), DAYS_NA = list('cd_days_na');
  /* cd_days_on (4.10): "w niedzielę|do niedzieli,..." - before | the day of handover, after | the "by" form for the order
     deadline (Sunday first); an entry without | serves both */
  var DAYS_ON = list('cd_days_on').map(function (x) { return x.split('|')[0].trim(); });
  var DAYS_BY = list('cd_days_on').map(function (x) { var p = x.split('|'); return (p[1] || p[0]).trim(); });
  var SHORT = {};
  raw('short_names').split(/\n/).forEach(function (line) {
    var m = line.split(/\s*(?:=|→|->)\s*/); if (m.length === 2 && m[0].trim() && m[1].trim()) SHORT[m[0].trim().toLowerCase()] = m[1].trim();
  });
  function shortName(n) { n = String(n || '').trim(); return SHORT[n.toLowerCase()] || n.replace(/^Batida\s+(Speciality\s+)?/i, ''); }
  function icon(n) { return IC[n] || ''; }
  /* 3 240 / 3,240 (Polish Intl leaves 4-digit numbers ungrouped; the design groups them) */
  function num(n) { return String(Math.round(Number(n) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, LANG === 'pl' ? '\u00a0' : ','); }
  function money(grosze) {
    if (window.batidaMoney) return window.batidaMoney(Math.round(Number(grosze) || 0));
    return ((Number(grosze) || 0) / 100).toLocaleString(LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł';
  }

  /* ---------- Warsaw calendar ---------- */
  var FMT = null;
  function wParts(d) {
    if (!FMT) FMT = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
    var o = {}; FMT.formatToParts(d).forEach(function (x) { o[x.type] = x.value; });
    var h = +o.hour === 24 ? 0 : +o.hour;
    return { y: +o.year, m: +o.month, d: +o.day, h: h, mi: +o.minute, s: +o.second, ymd: o.year + '-' + o.month + '-' + o.day, hm: pad(h) + ':' + o.minute };
  }
  /* a Warsaw wall-clock date + time as a real instant */
  function wInstant(ymd, hm) {
    var a = ymd.split('-').map(Number), b = String(hm || '00:00').split(':').map(Number);
    var guess = Date.UTC(a[0], a[1] - 1, a[2], b[0] || 0, b[1] || 0);
    var t = guess;
    for (var i = 0; i < 2; i++) { var p = wParts(new Date(t)); t = guess - (Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi, p.s) - t); }
    return new Date(t);
  }
  function ymdUTC(ymd) { var a = ymd.split('-').map(Number); return Date.UTC(a[0], a[1] - 1, a[2]); }
  function addDays(ymd, n) { return new Date(ymdUTC(ymd) + n * 864e5).toISOString().slice(0, 10); }
  function diffDays(from, to) { return Math.round((ymdUTC(to) - ymdUTC(from)) / 864e5); }
  function dow(ymd) { return new Date(ymdUTC(ymd)).getUTCDay(); }
  function normYmd(s) { var m = String(s || '').match(/^(\d{4})[\/.\-](\d{1,2})[\/.\-](\d{1,2})/); return m ? m[1] + '-' + pad(m[2]) + '-' + pad(m[3]) : ''; }
  function dm(ymd) { var a = ymd.split('-'); return (+a[2]) + '.' + a[1]; }
  function dmy(ymd) { var a = ymd.split('-'); return (+a[2]) + '.' + a[1] + '.' + a[0]; }
  function dayLabel(ymd) { return (ymd === TODAY ? raw('today') + ', ' : (DAYS[dow(ymd)] || '') + ' ') + dm(ymd); }
  var TODAY = wParts(new Date()).ymd;

  /* ---------- data ---------- */
  var D = DEMO ? demoData() : REAL;
  var S = { connect: undefined, openAdd: false, openInv: false, invDraft: null, msg: {} };

  function svcDate(o) { return normYmd(o.d) || (o.ts ? normYmd(raw('tshirt_date')) : ''); }
  function timeLabel(o) { return String(o.t || '').replace(/\s*-\s*/, '-'); }
  /* Aleksandra 29.09: "czw. 1.10, 12:00-15:00" for a delivery (the window from Delivery-Time), "czw. 1.10, od 13:00" for a
     pickup (Pickup-Time is the exact hour the customer chose - no invented window), the date only for DPD and T-shirts */
  function whenLabel(o) {
    if (!o._d) return '';
    var s = dayLabel(o._d);
    if (o.m === 'delivery' && o.t) s += ', ' + timeLabel(o);
    else if (o.m === 'pickup' && o.t) s += ', ' + raw('time_from').replace('{godzina}', String(o.t).trim());
    return s;
  }
  function isDead(o) { return o.cx || o.fin === 'refunded' || o.fin === 'voided'; }
  var ORDERS = (D.orders || []).map(function (o, i) { o._i = i; o._d = svcDate(o); return o; });
  var UPCOMING = ORDERS.filter(function (o) { return !isDead(o) && o._d && o._d >= TODAY; })
    .sort(function (a, b) { return (a._d + (a.t || '')).localeCompare(b._d + (b.t || '')); });
  var NEXT = UPCOMING[0] || null;

  function statusOf(o) {
    if (o.cx || o.fin === 'voided') return ['st_cancelled', 'bad'];
    if (o.fin === 'refunded') return ['st_refunded', 'bad'];
    if (o.fin === 'pending' || o.fin === 'partially_paid') return ['st_pending', 'warn'];
    if (o.fs) return ['st_accepted', 'ok'];
    return ['st_paid', 'ok'];
  }
  function whereLines(o) {
    var out = [];
    if (o.m === 'pickup' && o.loc) out.push(tx('where_pickup', { butik: esc(shortName(o.loc)) }));
    else if (o.m === 'delivery' && o.adr) out.push(tx('where_delivery', { adres: esc(o.adr) }));
    else if (o.m === 'shipping' && o.adr) out.push(tx('where_shipping', { adres: esc(o.adr) }));
    if (o.ts) { var td = normYmd(raw('tshirt_date')); out.push(tx('where_tshirt', { sposob: esc(o.ts), data: esc(td ? dm(td) : '') })); }
    return out;
  }
  function itemsLine(o, max) {
    var its = o.items || [];
    var shown = its.slice(0, max || 3).map(function (x) { return esc(x.t) + (x.q > 1 ? ' ×' + x.q : ''); }).join(', ');
    if (its.length > (max || 3)) shown += ' ' + tx('items_more', { n: its.length - (max || 3) });
    return shown;
  }

  /* ---------- small UI helpers ---------- */
  function toast(msg) {
    var el = document.querySelector('.v7k-toast');
    if (!el) { el = document.createElement('div'); el.className = 'v7k-toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = msg; el.classList.add('is-on');
    clearTimeout(el.__t); el.__t = setTimeout(function () { el.classList.remove('is-on'); }, 3800);
  }
  function blocked() { toast(raw('demo_blocked')); }
  function box(cls, inner, attrs) { return '<div class="v7k-box ' + cls + '"' + (attrs || '') + '>' + inner + '</div>'; }
  function h2(k, accentIcon) { return '<h2 class="v7k-h2">' + (accentIcon ? '<span class="v7k-ic" aria-hidden="true">' + icon(accentIcon) + '</span>' : '') + tx(k) + '</h2>'; }

  /* =====================================================================================================================
     RENDER
     ===================================================================================================================== */
  var TABS = [['start', 'tab_start'], ['zamowienia', 'tab_orders'], ['daty', 'tab_dates'], ['faktury', 'tab_invoice'], ['ustawienia', 'tab_settings']];
  var current = (location.hash || '').replace('#', '');
  if (!TABS.some(function (t) { return t[0] === current; })) current = 'start';

  function shell() {
    var first = D.first ? '<i>' + esc(D.first) + '</i>' : '';
    var sub = [];
    if (D.loy && CLUB.on) sub.push(tx('sub_points', { punkty: '<b>' + esc(num(D.loy.pts)) + '</b>' }));
    if (NEXT) sub.push(tx('sub_next', { kiedy: '<b>' + esc(whenLabel(NEXT)) + '</b>' }));
    var html = '';
    if (DEMO) html += '<div class="v7k-demo" role="note"><b>' + tx('demo_banner') + '</b> <span>' + tx('demo_note') + '</span> <a href="?kontodemo=0' + (params.get('view') ? '&view=' + encodeURIComponent(params.get('view')) : '') + '">' + tx('demo_off') + '</a></div>';
    html += '<div class="v7k-cd" data-v7k-cd hidden></div>';
    html += '<header class="v7k-hero"><div><h1 class="v7k-h1">' + (first ? tx('hello') + ' ' + first : tx('hello_noname')) + '</h1>' +
      (sub.length ? '<p class="v7k-hero__sub">' + sub.join(' ') + '</p>' : '') + '</div>' +
      '<div class="v7k-hero__side"><div class="v7k-slot" data-v7k-slot="hero"></div><p class="v7k-hero__acts"><a class="v7k-link v7k-link--muted" href="' + esc(root.getAttribute('data-logout') || '#') + '" rel="nofollow"' + (DEMO ? ' data-v7k-demo-block' : '') + '>' + tx('logout') + '</a></p></div></header>';
    html += '<div class="v7k-tabs" role="tablist" aria-label="' + tx('tab_start') + '">' + TABS.map(function (t) {
      return '<button type="button" role="tab" id="v7k-tab-' + t[0] + '" aria-controls="v7k-p-' + t[0] + '" data-v7k-tab="' + t[0] + '" aria-selected="false" tabindex="-1">' + tx(t[1]) + '</button>';
    }).join('') + '</div>';
    html += TABS.map(function (t) { return '<section class="v7k-panel" role="tabpanel" id="v7k-p-' + t[0] + '" aria-labelledby="v7k-tab-' + t[0] + '" data-v7k-panel="' + t[0] + '" hidden></section>'; }).join('');
    app.innerHTML = html;
    app.hidden = false;
    var g = document.querySelector('[data-v7k-guest]'); if (g) g.hidden = true;
  }

  function renderAll() {
    panel('start', pStart());
    panel('zamowienia', pOrders());
    panel('daty', pDates());
    panel('faktury', pInvoice());
    panel('ustawienia', pSettings());
    tabsState();
    nearestFill();
  }
  function panel(id, html) { var p = $('[data-v7k-panel="' + id + '"]'); if (p) { p.innerHTML = html; runFeatures(); } }
  function tabAvailable(id) { return id !== 'daty' || !!S.connect; }
  function tabsState() {
    if (!tabAvailable(current)) current = 'start';
    $$('[data-v7k-tab]').forEach(function (b) {
      var id = b.getAttribute('data-v7k-tab'), on = id === current;
      b.hidden = !tabAvailable(id);
      if (id === 'faktury') b.textContent = S.connect ? raw('tab_invoice') : raw('adr_title');
      b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
    });
    $$('[data-v7k-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-v7k-panel') !== current; });
    /* phones: keep the chosen tab in view inside the sideways-scrolling tab bar (no page scroll) */
    var bar = $('.v7k-tabs'), sel = $('[data-v7k-tab="' + current + '"]');
    if (bar && sel && bar.scrollWidth > bar.clientWidth) {
      var l = sel.offsetLeft - bar.offsetLeft, r = l + sel.offsetWidth;
      if (l < bar.scrollLeft) bar.scrollLeft = l - 16; else if (r > bar.scrollLeft + bar.clientWidth) bar.scrollLeft = r - bar.clientWidth + 16;
    }
  }
  function selectTab(id, focus) {
    if (!tabAvailable(id)) return;
    current = id; tabsState();
    try { history.replaceState(null, '', id === 'start' ? location.pathname + location.search : '#' + id); } catch (e) {}
    if (focus) { var b = $('[data-v7k-tab="' + id + '"]'); if (b) b.focus(); }
  }

  /* ---------- Start ---------- */
  function pStart() {
    var html = '<div class="v7k-grid"><div class="v7k-slot" data-v7k-slot="start-top"></div>';
    var loy = loyaltyBox();
    html += loy;
    html += box(loy ? 's7' : 's12', nextOrder());
    html += '<div class="v7k-slot" data-v7k-slot="start"></div></div>';
    return html;
  }

  function loyaltyBox() {
    var L = D.loy;
    if (!L || !CLUB.on) return '';
    var tiers = CLUB.tiers || [], cur = null, nxt = null;
    tiers.forEach(function (t) { if (String(t.id) === String(L.tier)) cur = t; if (String(t.id) === String(L.next)) nxt = t; });
    var pts = Number(L.pts) || 0;
    var rewards = (CLUB.rewards || []).map(function (r) {
      var min = parseFloat(String(r.min || '').replace(/[^\d.]/g, '')) || 0;
      return { pts: Number(r.pts) || 0, val: Math.round((parseFloat(r.val) || 0) * 100), min: Math.round(min * 100) };
    }).filter(function (r) { return r.pts > 0; }).sort(function (a, b) { return a.pts - b.pts; });
    var html = '<p class="v7k-kicker"><span class="v7k-ic" aria-hidden="true">' + icon('klub') + '</span>' + tx('loy_title') + '</p>';
    if (cur) html += '<span class="v7k-lvl">' + tx('loy_level', { poziom: esc(cur.name) }) + '</span>';
    html += '<div class="v7k-pts"><b>' + esc(num(pts)) + '</b><span>' + tx('loy_points') + '</span></div>';
    if (!L.max && nxt) {
      var prog = Math.max(0, Math.min(100, Number(L.prog) || 0));
      html += '<div class="v7k-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + prog + '" aria-label="' + esc(nxt.name) + '"><span style="width:' + prog + '%"></span></div>';
      var rem = parseFloat(L.rem);
      if (!isNaN(rem) && rem > 0) html += '<p class="v7k-small">' + tx('loy_next_tier', { poziom: '<b>' + esc(nxt.name) + '</b>', kwota: esc(money(rem * 100)) }) + '</p>';
    } else if (L.max) {
      html += '<p class="v7k-small">' + tx('loy_max_tier') + '</p>';
    }
    if (rewards.length) {
      html += '<div class="v7k-rw">' + rewards.map(function (r) {
        return '<div class="' + (pts >= r.pts ? 'is-ok' : '') + '"><b>' + esc(money(r.val)) + '</b><span>' + esc(num(r.pts)) + ' ' + tx('loy_points') + '</span>' +
          (r.min ? '<small>' + tx('loy_reward_min', { kwota: esc(money(r.min)) }) + '</small>' : '') + '</div>';
      }).join('') + '</div>';
      var best = rewards.filter(function (r) { return pts >= r.pts; }).pop();
      var goal = rewards.filter(function (r) { return pts < r.pts; })[0];
      if (best) html += '<p class="v7k-small">' + tx('loy_can_redeem', { kwota: '<b>' + esc(money(best.val)) + '</b>' }) + '</p>';
      else if (goal) html += '<p class="v7k-small">' + tx('loy_next_reward', { pkt: esc(num(goal.pts - pts)), kwota: esc(money(goal.val)) }) + '</p>';
    }
    /* Essential Loyalty's own widget opens on its rewards list (its documented hook: a click on [data-honeypop-route]).
       If the widget isn't on the page (not loaded, excluded customer, Klub Batida switch on), the click goes to
       Essential Loyalty's landing page instead, where the same redemption works. */
    html += L.connect
      ? '<p class="v7k-acts"><button type="button" class="v7k-btn v7k-btn--dark" data-loy-open-panel="rewards">' + tx('loy_btn') + '</button></p>'
      : '<p class="v7k-acts"><button type="button" class="v7k-btn v7k-btn--dark" data-honeypop-route="reward_list" data-v7k-el>' + tx('loy_btn') + '</button></p>';
    if (raw('loy_rule')) html += '<p class="v7k-small v7k-muted">' + tx('loy_rule') + '</p>';
    return box('s5 v7k-loy', html);
  }

  function nextOrder() {
    var html = h2('next_title');
    var o = NEXT;
    if (!o) {
      html += '<p class="v7k-sub">' + tx('next_none') + '</p><p class="v7k-acts"><a class="v7k-btn" href="' + esc(root.getAttribute('data-shop')) + '">' + tx('next_none_btn') + '</a></p>';
      return html;
    }
    var st = statusOf(o);
    html += '<p class="v7k-sub">' + esc(o.n) + ' · ' + itemsLine(o, 3) + '</p>';
    html += '<div class="v7k-next__when"><span class="v7k-ic" aria-hidden="true">' + icon('czas') + '</span><b>' + esc(whenLabel(o)) + '</b></div>';
    html += '<dl class="v7k-facts">';
    var w = whereLines(o);
    if (w.length) html += '<div><dt>' + tx('lbl_where') + '</dt><dd>' + w.join('<br>') + '</dd></div>';
    html += '<div><dt>' + tx('lbl_status') + '</dt><dd><span class="v7k-pill v7k-pill--' + st[1] + '">' + tx(st[0]) + '</span></dd></div></dl>';
    if (o.url) html += '<p class="v7k-acts"><a class="v7k-link" href="' + esc(o.url) + '"' + (DEMO ? ' data-v7k-demo-block' : '') + '>' + tx('next_details') + ' <span aria-hidden="true">→</span></a></p>';
    var mail = raw('change_email'), tel = raw('change_phone');
    html += '<div class="v7k-change"><p class="v7k-change__t"><b>' + tx('change_title') + '</b> ' + tx('change_sub') + '</p>' +
      '<p class="v7k-change__c">' + (mail ? '<a href="mailto:' + esc(mail) + '?subject=' + encodeURIComponent(o.n) + '">' + esc(mail) + '</a>' : '') +
      (tel ? '<a href="tel:' + esc(tel.replace(/[^\d+]/g, '')) + '">' + esc(tel) + '</a>' : '') + '</p>' +
      (raw('change_hours') ? '<p class="v7k-small">' + tx('change_hours') + '</p>' : '') +
      '<p class="v7k-small">' + tx('change_rule') + '</p>' +
      (o.m === 'pickup' && raw('change_place') ? '<p class="v7k-small">' + tx('change_place') + '</p>' : '') + '</div>';
    if (UPCOMING.length > 1) html += '<p class="v7k-small v7k-more"><button type="button" class="v7k-linkbtn" data-v7k-go="zamowienia">' + tx('next_more', { n: UPCOMING.length }) + '</button></p>';
    return html;
  }

  /* ---------- Zamówienia ---------- */
  var ORD_SHOWN = 5, ordAll = false;
  function pOrders() {
    var html = h2('ord_title');
    if (!ORDERS.length) return box('s12', html + '<p class="v7k-sub">' + tx('ord_none') + '</p>');
    html += '<p class="v7k-sub">' + tx('ord_sub') + '</p><div class="v7k-orders">';
    ORDERS.forEach(function (o, i) {
      if (!ordAll && i >= ORD_SHOWN) return;
      var pill = '';
      if (isDead(o)) { var st = statusOf(o); pill = '<span class="v7k-pill v7k-pill--' + st[1] + '">' + tx(st[0]) + '</span>'; }
      else if (o._d && o._d >= TODAY) pill = '<span class="v7k-pill v7k-pill--ok">' + tx('st_planned') + '</span>';
      var meta = [tx('ord_placed', { data: esc(dmy(o.c)) })];
      var w = whereLines(o);
      if (w.length) meta.push(w[0]);
      if (normYmd(o.d)) meta.push(esc(whenLabel(o)));
      var canAdd = (o.items || []).some(function (x) { return (x.s === 'ok' || x.s === 'swap') && x.v; });
      html += '<div class="v7k-order" data-v7k-order="' + o._i + '">' +
        '<div class="v7k-order__main"><p class="v7k-order__h"><b>' + esc(o.n) + '</b>' + pill + '</p>' +
        '<p class="v7k-order__m">' + meta.join(' · ') + '</p><p class="v7k-order__items">' + itemsLine(o, 4) + '</p></div>' +
        '<div class="v7k-order__side"><span class="v7k-order__sum"><b class="v7k-order__tot">' + esc(money(o.tot)) + '</b>' +
        (Number(o.sh) > 0 ? '<span class="v7k-order__ship">' + tx('ord_shipping', { kwota: esc(money(o.sh)) }) + '</span>' : '') + '</span><span class="v7k-order__btns">' +
        (canAdd ? '<button type="button" class="v7k-btn v7k-btn--sm" data-v7k-ro="' + o._i + '">' + tx('ord_reorder') + '</button>' : '') +
        (o.url ? '<a class="v7k-link" href="' + esc(o.url) + '"' + (DEMO ? ' data-v7k-demo-block' : '') + '>' + tx('ord_details') + '</a>' : '') + '</span></div>' +
        '<p class="v7k-order__msg" data-v7k-ro-msg="' + o._i + '" role="status" aria-live="polite"' + (S.msg[o._i] ? '' : ' hidden') + '>' + (S.msg[o._i] || '') + '</p></div>';
    });
    html += '</div>';
    var foot = [];
    if (!ordAll && ORDERS.length > ORD_SHOWN) foot.push('<button type="button" class="v7k-btn v7k-btn--sm" data-v7k-more>' + tx('ord_more') + '</button>');
    if (D.more || (D.count || 0) > ORDERS.length) foot.push('<a class="v7k-link" href="' + esc(root.getAttribute('data-account')) + '">' + tx('ord_all') + '</a>');
    if (foot.length) html += '<p class="v7k-acts">' + foot.join('') + '</p>';
    return box('s12', html);
  }

  var roBusy = false;
  function reorder(i, btn) {
    var o = ORDERS[i]; if (!o || roBusy) return;
    var addable = o.items.filter(function (x) { return (x.s === 'ok' || x.s === 'swap') && x.v; });
    var names = function (arr) { return arr.map(function (x) { return esc(x.t); }).join(', '); };
    if (!addable.length) { setRoMsg(i, tx('ro_none')); return; }
    roBusy = true; btn.disabled = true; var label = btn.textContent; btn.textContent = raw('ro_busy');
    var cartRoot = ROOT.replace(/\/$/, '');
    var ok = [], failed = [];
    var chain = Promise.resolve();
    addable.forEach(function (x) {
      chain = chain.then(function () {
        return fetch(cartRoot + '/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: x.v, quantity: Math.max(1, x.q || 1) }] }) })
          .then(function (r) { (r.ok ? ok : failed).push(x); }).catch(function () { failed.push(x); });
      });
    });
    chain.then(function () {
      var parts = [];
      if (ok.length) parts.push(tx('ro_added', { lista: names(ok) }));
      var sw = ok.filter(function (x) { return x.s === 'swap'; });
      if (sw.length) parts.push(tx('ro_inscr', { lista: names(sw) }));
      var man = o.items.filter(function (x) { return x.s === 'manual'; });
      if (man.length) parts.push(tx('ro_manual', { lista: names(man) }));
      var sk = o.items.filter(function (x) { return x.s === 'skip'; });
      if (sk.length) parts.push(tx('ro_skip', { lista: names(sk) }));
      var na = o.items.filter(function (x) { return x.s === 'na'; }).concat(failed);
      if (na.length) parts.push(tx('ro_na', { lista: names(na) }));
      if (!ok.length) parts.unshift(tx('ro_error'));
      setRoMsg(i, parts.join(' '));
      if (!ok.length) return;
      return fetch(cartRoot + '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        try { document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart } })); } catch (e) {}
        if (typeof window.__batidaOpenCart === 'function') window.__batidaOpenCart();
      }).catch(function () {});
    }).then(function () { roBusy = false; btn.disabled = false; btn.textContent = label; });
  }
  function setRoMsg(i, html) {
    S.msg[i] = html;
    var el = $('[data-v7k-ro-msg="' + i + '"]'); if (el) { el.innerHTML = html; el.hidden = !html; }
  }

  /* ---------- Ważne daty (Batida Connect) ---------- */
  function nextOcc(mmdd) {
    var m = String(mmdd || '').match(/^(\d{2})-(\d{2})$/); if (!m) return null;
    var y = +TODAY.slice(0, 4), cand = y + '-' + m[1] + '-' + m[2];
    if (normYmd(cand) !== cand || cand < TODAY) cand = (y + 1) + '-' + m[1] + '-' + m[2];
    return cand;
  }
  function pDates() {
    var C = S.connect; if (!C) return '';
    var dates = (C.dates || []).map(function (d) { var nx = normYmd(d.next); return { d: d, at: nx && nx >= TODAY ? nx : nextOcc(d.date) }; }).filter(function (x) { return x.at; })
      .sort(function (a, b) { return a.at.localeCompare(b.at); });
    var html = h2('dates_title', 'przypomnienie') + '<p class="v7k-sub">' + tx('dates_sub') + '</p>';
    if (!dates.length) html += '<p class="v7k-empty">' + tx('dates_none') + '</p>';
    html += dates.map(function (x) {
      var d = x.d, n = diffDays(TODAY, x.at), mm = +x.at.slice(5, 7), dd = +x.at.slice(8, 10);
      var rem = normYmd(d.remindOn);
      var when = n === 0 ? raw('today') : n === 1 ? raw('dates_tomorrow') : raw('dates_in').replace('{n}', n);
      var src = d.source === 'cart' ? (d.orderName ? tx('dates_from_order', { nr: esc(d.orderName) }) : tx('dates_from_cart')) : tx('dates_own');
      var title = [d.person, d.label].filter(Boolean).join(' - '); title = esc(title.charAt(0).toUpperCase() + title.slice(1));
      return '<div class="v7k-date"><div class="v7k-day' + (n <= 14 ? ' is-soon' : '') + '"><b>' + dd + '</b><span>' + esc(MONTHS_S[mm - 1] || '') + '</span></div>' +
        '<div><b>' + title + '</b> <span class="v7k-chip">' + esc(when) + '</span><div class="v7k-small">' + src + (rem ? ' · ' + tx('dates_remind', { data: esc(dm(rem)) }) : '') + '</div></div>' +
        '<button type="button" class="v7k-linkbtn" data-v7k-date-del="' + esc(d.id) + '">' + tx(d.source === 'cart' ? 'dates_off' : 'dates_remove') + '</button></div>';
    }).join('');
    var dayOpts = '<option value="">' + tx('dates_day') + '</option>';
    for (var i = 1; i <= 31; i++) dayOpts += '<option value="' + pad(i) + '">' + i + '</option>';
    var monOpts = '<option value="">' + tx('dates_month') + '</option>' + MONTHS.map(function (m, k) { return '<option value="' + pad(k + 1) + '">' + esc(m) + '</option>'; }).join('');
    html += '<form class="v7k-form v7k-form--date" data-v7k-date-form novalidate><p class="v7k-form__t">' + tx('dates_add_title') + '</p><div class="v7k-form__row">' +
      '<label><span>' + tx('dates_person') + '</span><input name="person" maxlength="60" placeholder="' + tx('dates_person_ph') + '" autocomplete="off"></label>' +
      '<label><span>' + tx('dates_label') + '</span><input name="label" maxlength="60" list="v7k-occ" placeholder="' + tx('dates_label_ph') + '" autocomplete="off"></label>' +
      '<label><span>' + tx('dates_day') + '</span><select name="day">' + dayOpts + '</select></label>' +
      '<label><span>' + tx('dates_month') + '</span><select name="month">' + monOpts + '</select></label>' +
      '<button type="submit" class="v7k-btn v7k-btn--dark">' + tx('dates_save') + '</button></div>' +
      '<datalist id="v7k-occ">' + list('dates_suggest').map(function (x) { return '<option value="' + esc(x) + '">'; }).join('') + '</datalist>' +
      '<p class="v7k-form__msg" data-v7k-date-msg role="status" aria-live="polite"></p></form>';
    /* slot "daty" (14.10): "Twoje daty w kalendarzu" under the dates card (assets/batida-konto-kalendarz.js) */
    return '<div class="v7k-grid">' + box('s12', html) + '<div class="v7k-slot" data-v7k-slot="daty"></div></div>';
  }

  /* ---------- Faktury i adresy ---------- */
  function pInvoice() {
    var html = '<div class="v7k-grid">';
    if (S.connect) html += box('s7', invoiceBox());
    html += box(S.connect ? 's5' : 's12', addressesBox());
    return html + '<div class="v7k-slot" data-v7k-slot="faktury"></div></div>';
  }
  function nipFmt(n) { n = String(n || '').replace(/\D/g, ''); return n.length === 10 ? n.slice(0, 3) + '-' + n.slice(3, 6) + '-' + n.slice(6, 8) + '-' + n.slice(8) : n; }
  function invoiceBox() {
    var inv = (S.connect.profile && S.connect.profile.invoice) || { always: false, nips: [] };
    var nips = inv.nips || [];
    var html = h2('inv_title') + '<p class="v7k-sub">' + tx('inv_sub') + '</p>';
    if (!nips.length) html += '<p class="v7k-empty">' + tx('inv_none') + '</p>';
    html += nips.map(function (c, i) {
      return '<div class="v7k-inv' + (i === 0 ? ' is-first' : '') + '"><div><b>' + esc(c.name || nipFmt(c.nip)) + '</b>' + (i === 0 ? '<span class="v7k-badge">' + tx('inv_first') + '</span>' : '') +
        '<div class="v7k-small">' + tx('inv_nip') + ' ' + esc(nipFmt(c.nip)) + (c.street || c.city ? '<br>' + esc([c.street, [c.zip, c.city].filter(Boolean).join(' ')].filter(Boolean).join(', ')) : '') + '</div></div>' +
        '<div class="v7k-inv__acts">' + (i > 0 ? '<button type="button" class="v7k-linkbtn" data-v7k-inv-first="' + i + '">' + tx('inv_make_first') + '</button>' : '') +
        '<button type="button" class="v7k-linkbtn" data-v7k-inv-del="' + i + '">' + tx('inv_remove') + '</button></div></div>';
    }).join('');
    html += '<label class="v7k-sw"><input type="checkbox" data-v7k-always' + (inv.always ? ' checked' : '') + (nips.length ? '' : ' disabled') + '><span><b>' + tx('inv_always') + '</b><br><span class="v7k-small">' +
      (nips.length ? tx('inv_always_sub') : tx('inv_always_need')) + '</span></span></label>';
    if (S.openInv) {
      var f = S.invDraft || {};
      html += '<form class="v7k-form" data-v7k-inv-form novalidate><div class="v7k-form__grid">' +
        '<label class="v7k-form__nip"><span>' + tx('inv_nip') + '</span><input name="nip" inputmode="numeric" autocomplete="off" maxlength="13" value="' + esc(f.nip || '') + '"></label>' +
        '<p class="v7k-small v7k-form__look" data-v7k-look role="status" aria-live="polite">' + tx('inv_hint') + '</p>' +
        '<label class="v7k-form__wide"><span>' + tx('inv_name') + '</span><input name="name" maxlength="200" value="' + esc(f.name || '') + '"></label>' +
        '<label class="v7k-form__wide"><span>' + tx('inv_street') + '</span><input name="street" maxlength="200" value="' + esc(f.street || '') + '"></label>' +
        '<label><span>' + tx('inv_zip') + '</span><input name="zip" maxlength="10" value="' + esc(f.zip || '') + '"></label>' +
        '<label><span>' + tx('inv_city') + '</span><input name="city" maxlength="100" value="' + esc(f.city || '') + '"></label></div>' +
        '<p class="v7k-acts"><button type="submit" class="v7k-btn v7k-btn--dark">' + tx('inv_save') + '</button><button type="button" class="v7k-linkbtn" data-v7k-inv-cancel>' + tx('inv_cancel') + '</button></p>' +
        '<p class="v7k-form__msg" data-v7k-inv-msg role="status" aria-live="polite"></p></form>';
    } else if (nips.length < 5) {
      html += '<p class="v7k-acts"><button type="button" class="v7k-btn" data-v7k-inv-add>' + tx('inv_add') + '</button></p>';
    } else {
      html += '<p class="v7k-small">' + tx('inv_max') + '</p>';
    }
    return html;
  }
  function addressesBox() {
    var html = h2('adr_title', 'lokalizacja') + '<p class="v7k-sub">' + tx('adr_sub') + '</p>';
    var A = D.addr || [];
    if (!A.length) html += '<p class="v7k-empty">' + tx('adr_none') + '</p>';
    html += A.map(function (a) {
      var head = a.co || a.name || a.a1;
      var line = [a.a1, a.a2].filter(Boolean).join(' ') + (a.zip || a.city ? ', ' + [a.zip, a.city].filter(Boolean).join(' ') : '');
      return '<div class="v7k-row"><div><b>' + esc(head) + '</b><div class="v7k-small">' + esc(line) + '<br><span data-v7k-near="' + esc(a.zip || '') + '"></span></div></div>' +
        (a.def ? '<span class="v7k-chip">' + tx('adr_default') + '</span>' : '') + '</div>';
    }).join('');
    html += '<p class="v7k-acts"><a class="v7k-link" href="' + esc(root.getAttribute('data-addresses')) + '"' + (DEMO ? ' data-v7k-demo-block' : '') + '>' + tx('adr_edit') + ' <span aria-hidden="true">→</span></a></p>' +
      '<p class="v7k-small v7k-muted">' + tx('adr_edit_note') + '</p>';
    return html;
  }

  /* ---------- Ustawienia ---------- */
  function pSettings() {
    var nl = S.connect && S.connect.newsletter;
    var subscribed = nl && typeof nl.subscribed === 'boolean' ? nl.subscribed : !!D.news;
    var html = h2('set_title');
    html += '<div class="v7k-row v7k-row--top"><div><b>' + tx('nl_title') + '</b><div class="v7k-small">' + tx('nl_desc') + '</div>' +
      '<div class="v7k-small v7k-nl-state">' + tx(subscribed ? 'nl_on' : 'nl_off') + '</div>';
    if (nl && nl.canChange) {
      html += '</div><label class="v7k-switch"><input type="checkbox" data-v7k-nl' + (subscribed ? ' checked' : '') + '><span class="v7k-sr">' + tx('nl_toggle') + '</span><i aria-hidden="true"></i></label></div>';
    } else if (!subscribed) {
      html += (params.get('customer_posted') === 'true' ? '<div class="v7k-small v7k-ok">' + tx('nl_done') + '</div>' : '') + '</div>' +
        '<button type="button" class="v7k-btn v7k-btn--sm" data-v7k-nl-sub>' + tx('nl_sub_btn') + '</button></div>';
    } else {
      html += '<div class="v7k-small">' + tx('nl_unsub_how') + '</div></div></div>';
    }
    html += '<div class="v7k-row"><div><b>' + tx('acc_profile') + '</b><div class="v7k-small">' + tx('acc_profile_desc') + '</div></div>' +
      '<a class="v7k-link" href="' + esc(root.getAttribute('data-profile') || root.getAttribute('data-account')) + '"' + (DEMO ? ' data-v7k-demo-block' : '') + '>' + tx('acc_title') + ' <span aria-hidden="true">→</span></a></div>';   /* 4.10: Shopify profile (name, e-mail, addresses), not Orders */
    return '<div class="v7k-grid">' + box('s7', html) + '<div class="v7k-slot" data-v7k-slot="ustawienia"></div></div>';
  }

  /* =====================================================================================================================
     "ZAMÓW NA JUTRO" COUNTDOWN - 4.10 (Aleksandra 17:17): Batida Connect's rule for 24 h products (tagCutoff 21:00):
     order by 21:00 on the day before the first OPEN day (nothing is handed over on Sundays and on Connect's closed days).
     assets/batida-nextday.js counts it from Connect's calendar (/apps/connect/kalendarz). Examples:
       Sunday 17:00   -> "Zamów dziś do 21:00, a odbierzesz lub dostarczymy jutro."
       Saturday       -> "Zamów do niedzieli do 21:00, a odbierzesz lub dostarczymy w poniedziałek 12.10."
       Tuesday 10.11  -> "Zamów do środy do 21:00, a odbierzesz lub dostarczymy w czwartek 12.11." (11.11 closed)
     Until 4.10 this asked Connect with an empty cart, which gave the old "24 h before the slot" rule ("Zamów do 10:00
     jutro ... wtorek 6.10"). Texts: cd_text {dzien} {godzina} {kiedy} ({okno} is no longer filled); cd_today; cd_tomorrow;
     cd_days_on (see above); buttons cd_btn / cd_btn_day. Connect without the cut-off rule = no countdown.
     Test: ?bnd_now=2026-10-10T15:00 (assets/batida-nextday.js) pretends that Warsaw time in this tab.
     ===================================================================================================================== */
  var CD = { info: null, timer: null, nd: null };
  function nextDay(cb) {
    if (window.BatidaNextDay) return cb(window.BatidaNextDay);
    var done = false;
    function go() { if (!done && window.BatidaNextDay) { done = true; cb(window.BatidaNextDay); } }
    document.addEventListener('bnd:ready', go);
    /* the helper is loaded by the pink strip (sections/batida-free-delivery-bar); if that is off, load it next to this file */
    setTimeout(function () {
      if (window.BatidaNextDay) return go();
      var me = document.querySelector('script[src*="batida-konto.js"]');
      if (!me) return;
      var s = document.createElement('script'); s.src = me.src.replace('batida-konto.js', 'batida-nextday.js'); s.onload = go; document.head.appendChild(s);
    }, 1500);
  }
  function loadSlots() {
    nextDay(function (N) {
      CD.nd = N;
      N.get().then(function (info) {
        CD.info = info;
        tick(); clearInterval(CD.timer); CD.timer = setInterval(tick, 1000);
      }).catch(function () {});
    });
  }
  function relDay(ymd, today) {
    var n = diffDays(today, ymd);
    if (n === 0) return raw('cd_today');
    if (n === 1) return raw('cd_tomorrow');
    return (DAYS_ON[dow(ymd)] || '') + ' ' + dm(ymd);
  }
  function tick() {
    var el = $('[data-v7k-cd]'); if (!el) return;
    var N = CD.nd, now = N ? N.now() : Date.now(), s = CD.info;
    /* the deadline has passed (21:00) or a new day began: count again (Connect's data is kept by the helper) */
    if (s && (now >= s.deadlineAt || wParts(new Date(now)).ymd !== s.today)) s = CD.info = N.current();
    if (!s) { el.hidden = true; clearInterval(CD.timer); return; }
    var left = Math.max(0, Math.floor((s.deadlineAt - now) / 1000));
    var clock = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor(left % 3600 / 60)) + ':' + pad(left % 60);
    var text = tx('cd_text', { godzina: '<b>' + esc(s.cutoff) + '</b>', dzien: '<b>' + esc(s.deadlineToday ? raw('cd_today') : (DAYS_BY[dow(s.deadline)] || dm(s.deadline))) + '</b>',
      kiedy: '<b>' + esc(relDay(s.day, s.today)) + '</b>', okno: '' });
    var btn = s.dayTomorrow ? tx('cd_btn') : tx('cd_btn_day', { dzien: esc(DAYS_NA[dow(s.day)] || dm(s.day)) });
    var key = s.day + '|' + s.deadline + '|' + LANG;
    if (el.__key !== key) {
      el.__key = key;
      el.innerHTML = '<div class="v7k-cd__clock"><span class="v7k-cd__k"><span class="v7k-ic" aria-hidden="true">' + icon('czas') + '</span>' + tx('cd_kicker') + '</span><b class="v7k-cd__t" data-v7k-cd-t></b></div>' +
        '<div class="v7k-cd__txt"><p>' + text + '</p><p class="v7k-cd__note">' + tx('cd_note') + '</p></div>' +
        '<a class="v7k-cd__btn" href="' + esc(root.getAttribute('data-shop')) + '">' + btn + '</a>';
    }
    var t = $('[data-v7k-cd-t]', el); if (t) t.textContent = clock;
    el.hidden = false;
  }

  /* ---------- nearest boutique for each address postcode (the cart's "Najbliżej Ciebie" data) ---------- */
  var NEAR = {};
  function nearest(zip) {
    if (NEAR[zip]) return NEAR[zip];
    var base = (window.BatidaConnect && window.BatidaConnect.api) || CONNECT;
    NEAR[zip] = fetch(base + 'v1.0/pickup/locations', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ geoSearchQuery: zip, shoppingCart: [] }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (j) { var l = (j.locations || []).filter(function (x) { return x.distance != null; })[0]; return l ? { name: shortName(l.company_name), km: l.distance } : null; })
      .catch(function () { return null; });
    return NEAR[zip];
  }
  function nearestFill() {
    $$('[data-v7k-near]').forEach(function (el) {
      var zip = String(el.getAttribute('data-v7k-near') || '').trim();
      if (!/^\d{2}-\d{3}$/.test(zip)) return;
      nearest(zip).then(function (n) {
        if (!n || !el.isConnected) return;
        el.innerHTML = tx('adr_near', { butik: '<b>' + esc(n.name) + '</b>', km: esc((Math.round(n.km * 10) / 10).toLocaleString(LOCALE) + ' km') });
      });
    });
  }

  /* =====================================================================================================================
     BATIDA CONNECT (/apps/connect/konto): dates, invoice profile, newsletter
     ===================================================================================================================== */
  var PROFILE_KEY = 'v7k-prof', RELOAD_KEY = 'v7k-resign';
  /* Writes use POST only (Batida Connect's aliases: POST /profile = PUT, POST /dates/<id>/delete = DELETE), because the
     Shopify app proxy is only guaranteed for GET and POST. Errors always come as {ok:false, error}. A 401 "bad_signature"
     (the page's proxy signature went stale) reloads the page once; after that it is a normal error. */
  function connectApi(method, path, body) {
    return fetch('/apps/connect/konto' + (path || ''), { method: method, credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) {
        return r.json().catch(function () { return null; }).then(function (j) {
          if (!r.ok || !j || j.ok === false) {
            var e = new Error((j && j.error) || 'http ' + r.status); e.status = r.status; e.j = j || {};
            if (r.status === 401 && e.j.error === 'bad_signature' && !sget(RELOAD_KEY)) { sset(RELOAD_KEY, '1'); location.reload(); }
            throw e;
          }
          sset(RELOAD_KEY, null);
          return j;
        });
      });
  }
  /* the message for a failed write: 429 = wait, anything else = the generic line */
  function errText(err) {
    if (err && err.status === 429) return raw('err_rate').replace('{s}', Math.max(1, Math.ceil(Number(err.j && err.j.retryAfter) || 30)));
    return raw('err_generic');
  }
  /* 5.10 Klub Batida in Batida Connect (replaces Essential Loyalty at the switch, ~12.10). When Connect's widgets are on
     (snippets/batida-loyalty-switch: theme setting loyalty_widget = connect, or ?loy=1 in this browser) the Start box
     reads points, tier and rewards from /apps/connect/loyalty/{me,program} instead of EL's frozen customer metafield,
     and its button opens Connect's rewards panel. Otherwise (today) nothing changes. */
  var CONNECT_LOY = !!(window.BatidaLoyalty && !window.BatidaLoyalty.x && !window.BatidaLoyalty.mock);
  function loadConnectLoyalty() {
    if (DEMO || !CONNECT_LOY || !D.id) return Promise.resolve(false);
    var get = function (p) { return fetch('/apps/connect/loyalty/' + p + '?lang=' + encodeURIComponent(LANG), { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }); };
    return Promise.all([get('me'), get('program')]).then(function (r) {
      var me = r[0], pr = r[1];
      if (!me || !me.loggedIn || me.excluded || !me.tier) { D.loy = null; return true; }
      var t = me.tier;
      D.loy = { pts: me.balance || 0, tier: t.id, next: t.next ? t.next.id : null, prog: t.progress || 0, max: !t.next, rem: t.next ? String(t.next.remaining) : '0', connect: true };
      CLUB = { on: true, tiers: (pr.tiers || []).map(function (x) { return { id: x.id, name: x.name }; }),
        rewards: (pr.rewards || []).map(function (x) { return { pts: x.cost, val: x.value, min: String(x.minOrder || 0) }; }) };
      return true;
    }).catch(function () { return false; });   // Connect not answering: keep what the page printed (EL)
  }
  function loadConnect() {
    if (DEMO) return Promise.resolve(demoConnect());
    /* ?locale: features.quiz depends on the page's language (questions per language) */
    return connectApi('GET', '?locale=' + encodeURIComponent(LANG)).then(function (j) { return j.enabled ? j : null; }).catch(function () { return null; });
  }
  /* the cart's pre-fill (assets/batida-konto-cart.js) reads the same profile; keep its short cache fresh */
  function cacheProfile() {
    if (DEMO || !S.connect || !D.id) return;
    sset(PROFILE_KEY, JSON.stringify({ id: String(D.id), at: Date.now(), profile: S.connect.profile || null, rewards: Array.isArray(S.connect.rewards) ? S.connect.rewards : [], warnings: Array.isArray(S.connect.warnings) ? S.connect.warnings : [] }));
  }
  function saveProfile(patch) {
    if (DEMO) { blocked(); return Promise.reject(new Error('demo')); }
    return connectApi('POST', '/profile', patch).then(function (j) {
      S.connect.profile = j.profile || S.connect.profile; cacheProfile(); return j;
    });
  }

  /* ---------- MF VAT register lookup (same API as the cart's NIP autofill) ---------- */
  function validNip(n) {
    n = String(n || '').replace(/\D/g, ''); if (!/^\d{10}$/.test(n)) return false;
    var w = [6, 5, 7, 2, 3, 4, 5, 6, 7], s = 0; for (var i = 0; i < 9; i++) s += +n[i] * w[i];
    return s % 11 !== 10 && s % 11 === +n[9];
  }
  function mfLookup(nip) {
    return fetch('https://wl-api.mf.gov.pl/api/search/nip/' + nip + '?date=' + TODAY, { mode: 'cors', credentials: 'omit' })
      .then(function (r) { if (r.status === 404 || r.status === 400) return null; if (!r.ok) throw new Error('mf ' + r.status); return r.json(); })
      .then(function (j) {
        var sub = j && j.result && j.result.subject; if (!sub) return null;
        var a = String(sub.workingAddress || sub.residenceAddress || '').replace(/\s+/g, ' ').trim(), c = a.lastIndexOf(',');
        var out = { name: sub.name || '', street: a, zip: '', city: '' };
        if (c > 0) { var m = a.slice(c + 1).trim().match(/^(\d{2}-\d{3})\s+(.+)$/); if (m) { out.street = a.slice(0, c).trim(); out.zip = m[1]; out.city = m[2]; } }
        return out;
      });
  }

  /* =====================================================================================================================
     EVENTS
     ===================================================================================================================== */
  app.addEventListener('click', function (e) {
    var t = e.target;
    var tab = t.closest('[data-v7k-tab]'); if (tab) { selectTab(tab.getAttribute('data-v7k-tab')); return; }
    var go = t.closest('[data-v7k-go]'); if (go) { selectTab(go.getAttribute('data-v7k-go')); try { app.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (x) {} return; }
    if (t.closest('[data-v7k-demo-block]') && DEMO) { e.preventDefault(); blocked(); return; }
    var el = t.closest('[data-v7k-el]');
    if (el) {
      var w = document.getElementById('honeypop-app');
      var mounted = w && w.childElementCount > 0 && !document.documentElement.classList.contains('loy-on') && getComputedStyle(w).display !== 'none';
      if (!mounted) { var page = root.getAttribute('data-loy-page'); if (page) location.href = page; }
      return;   // mounted: Essential Loyalty's own document click listener opens its rewards list
    }
    var ro = t.closest('[data-v7k-ro]'); if (ro) { reorder(+ro.getAttribute('data-v7k-ro'), ro); return; }
    if (t.closest('[data-v7k-more]')) { ordAll = true; panel('zamowienia', pOrders()); return; }
    var dd = t.closest('[data-v7k-date-del]');
    if (dd) {
      if (DEMO) { blocked(); return; }
      var id = dd.getAttribute('data-v7k-date-del'); dd.disabled = true;
      connectApi('POST', '/dates/' + encodeURIComponent(id) + '/delete').then(function () {
        S.connect.dates = (S.connect.dates || []).filter(function (x) { return String(x.id) !== String(id); });
        panel('daty', pDates()); toast(raw('saved'));
      }).catch(function (err) { dd.disabled = false; toast(errText(err)); });
      return;
    }
    if (t.closest('[data-v7k-inv-add]')) { S.openInv = true; S.invDraft = null; panel('faktury', pInvoice()); nearestFill(); var n = $('[data-v7k-inv-form] input[name="nip"]'); if (n) n.focus(); return; }
    if (t.closest('[data-v7k-inv-cancel]')) { S.openInv = false; panel('faktury', pInvoice()); nearestFill(); return; }
    var del = t.closest('[data-v7k-inv-del]'), first = t.closest('[data-v7k-inv-first]');
    if (del || first) {
      if (DEMO) { blocked(); return; }
      var nips = ((S.connect.profile && S.connect.profile.invoice && S.connect.profile.invoice.nips) || []).slice();
      if (del) nips.splice(+del.getAttribute('data-v7k-inv-del'), 1);
      else { var k = +first.getAttribute('data-v7k-inv-first'); nips.unshift(nips.splice(k, 1)[0]); }
      var patch = { invoice: { nips: nips } }; if (!nips.length) patch.invoice.always = false;
      (del || first).disabled = true;
      saveProfile(patch).then(function () { panel('faktury', pInvoice()); nearestFill(); toast(raw('saved')); })
        .catch(function (err) { (del || first).disabled = false; if (err.message !== 'demo') toast(errText(err)); });
      return;
    }
    if (t.closest('[data-v7k-nl-sub]')) {
      if (DEMO) { blocked(); return; }
      var nf = document.querySelector('[data-v7k-news-form]'); if (!nf) return;
      var b = t.closest('[data-v7k-nl-sub]'); b.disabled = true; b.textContent = raw('nl_sub_busy');
      if (nf.requestSubmit) nf.requestSubmit(); else nf.submit();
    }
  });

  app.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-v7k-tab]'); if (!tab) return;
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'Home' && e.key !== 'End') return;
    var tabs = $$('[data-v7k-tab]').filter(function (b) { return !b.hidden; }), i = tabs.indexOf(tab);
    var j = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    e.preventDefault(); selectTab(tabs[j].getAttribute('data-v7k-tab'), true);
  });

  app.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-v7k-always]')) {
      if (DEMO) { t.checked = !t.checked; blocked(); return; }
      t.disabled = true;
      saveProfile({ invoice: { always: t.checked } }).then(function () { toast(raw('saved')); })
        .catch(function (err) { t.checked = !t.checked; toast(errText(err)); }).then(function () { t.disabled = false; });
      return;
    }
    if (t.matches('[data-v7k-nl]')) {
      if (DEMO) { t.checked = !t.checked; blocked(); return; }
      var want = t.checked; t.disabled = true;
      connectApi('POST', '/newsletter', { subscribed: want }).then(function (j) {
        var nj = j.newsletter || j;
        S.connect.newsletter.subscribed = typeof nj.subscribed === 'boolean' ? nj.subscribed : want; panel('ustawienia', pSettings()); toast(raw('saved'));
      }).catch(function (err) {
        if (err.status === 409) S.connect.newsletter.canChange = false;
        t.checked = !want; panel('ustawienia', pSettings()); toast(errText(err));
      });
    }
  });

  var lookT = null, lastNip = '';
  app.addEventListener('input', function (e) {
    var t = e.target; if (!t.matches('[data-v7k-inv-form] input[name="nip"]')) return;
    var clean = t.value.replace(/\D/g, '').slice(0, 10); if (clean !== t.value) t.value = clean;
    clearTimeout(lookT);
    lookT = setTimeout(function () {
      var msg = $('[data-v7k-look]'), form = t.form; if (!msg || !form) return;
      if (clean.length < 10) { msg.textContent = raw('inv_hint'); lastNip = ''; return; }
      if (clean === lastNip) return;
      if (!validNip(clean)) { msg.textContent = raw('inv_nip_bad'); return; }
      lastNip = clean; msg.textContent = raw('inv_look_load');
      mfLookup(clean).then(function (c) {
        if (!c) { msg.textContent = raw('inv_look_nf'); return; }
        ['name', 'street', 'zip', 'city'].forEach(function (k) { if (form.elements[k] && c[k]) form.elements[k].value = c[k]; });
        msg.textContent = raw('inv_look_ok');
      }).catch(function () { msg.textContent = raw('inv_look_err'); });
    }, 350);
  });

  app.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-v7k-date-form]')) {
      e.preventDefault();
      var msg = $('[data-v7k-date-msg]', f);
      var day = f.elements.day.value, mon = f.elements.month.value, label = f.elements.label.value.trim(), person = f.elements.person.value.trim();
      var ok = day && mon && label && normYmd('2024-' + mon + '-' + day) === '2024-' + mon + '-' + day;   /* 2024: 29.02 allowed */
      if (!ok) { msg.textContent = raw('dates_err'); return; }
      if (DEMO) { blocked(); return; }
      var btn = f.querySelector('button[type="submit"]'); btn.disabled = true;
      connectApi('POST', '/dates', { date: mon + '-' + day, label: label, person: person }).then(function (j) {
        var have = (S.connect.dates || []).some(function (x) { return j.date && String(x.id) === String(j.date.id); });
        if (j.date && !have) S.connect.dates = (S.connect.dates || []).concat([j.date]);
        panel('daty', pDates()); toast(raw('saved'));
      }).catch(function (err) {
        btn.disabled = false;
        msg.textContent = err.status === 409 && err.j.error === 'limit' ? raw('dates_limit').replace('{max}', err.j.max || 20) : errText(err);
      });
      return;
    }
    if (f.matches('[data-v7k-inv-form]')) {
      e.preventDefault();
      var m = $('[data-v7k-inv-msg]', f);
      var c = { nip: f.elements.nip.value.replace(/\D/g, ''), name: f.elements.name.value.trim(), street: f.elements.street.value.trim(), zip: f.elements.zip.value.trim(), city: f.elements.city.value.trim() };
      if (!validNip(c.nip)) { m.textContent = raw('inv_nip_bad'); return; }
      if (!c.name) { m.textContent = raw('inv_need_name'); return; }
      if (DEMO) { blocked(); return; }
      var nips = ((S.connect.profile && S.connect.profile.invoice && S.connect.profile.invoice.nips) || []).filter(function (x) { return String(x.nip).replace(/\D/g, '') !== c.nip; });
      if (nips.length >= 5) { m.textContent = raw('inv_max'); return; }
      nips.push(c);
      var sb = f.querySelector('button[type="submit"]'); sb.disabled = true;
      saveProfile({ invoice: { nips: nips } }).then(function () {
        S.openInv = false; panel('faktury', pInvoice()); nearestFill(); toast(raw('saved'));
      }).catch(function (err) {
        sb.disabled = false;
        m.textContent = err.status === 400 && err.j.field ? raw('inv_err_nip') : errText(err);
      });
    }
  });

  window.addEventListener('hashchange', function () { var h = location.hash.replace('#', ''); if (TABS.some(function (t) { return t[0] === h; })) selectTab(h); });

  /* =====================================================================================================================
     SAMPLE DATA (review mode only) - clearly fictional person and order numbers; products and prices are real
     ===================================================================================================================== */
  function demoData() {
    var L = DEMO_LINES || {};
    function day(ymd) { return ymd.replace(/-/g, '/'); }
    function created(n) { return addDays(TODAY, n); }
    function it(k, q) { var x = L[k] || { t: k, q: 1, v: 0, s: 'na', pr: 0 }; return q ? Object.assign({}, x, { q: q }) : x; }
    /* totals add up: live prices of the sample lines + Warsaw delivery from the shop's real rates (48,00 zł, free from 500 zł) */
    var R = (window.batidaFD && window.batidaFD.rates) || {}, DELIV = Number(R.warsaw) || 4800, FREE = Number(R.freeFrom) || 50000;
    function order(o) {
      var sub = o.items.reduce(function (a, x) { return a + (Number(x.pr) || 0) * (x.q || 1); }, 0);
      o.sh = o.m === 'delivery' && sub < FREE ? DELIV : 0; o.tot = sub + o.sh;
      o.fin = o.fin || 'paid'; o.cx = !!o.cx; o.url = '#'; o.loc = o.loc || ''; o.adr = o.adr || ''; o.ts = o.ts || ''; o.t = o.t || ''; o.d = o.d || ''; o.m = o.m || '';
      return o;
    }
    /* Aleksandra's example: the next order is a Warsaw delivery on czw. 1.10, 12:00-15:00 (the next Thursday once 1.10 is past) */
    var nd = '2026-10-01';
    if (nd <= TODAY) { nd = addDays(TODAY, 1); while (dow(nd) !== 4) nd = addDays(nd, 1); }
    var tier = (CLUB.tiers || [])[1] || (CLUB.tiers || [])[0], next = (CLUB.tiers || [])[2];
    return {
      id: 0, first: 'Anna', news: false,
      loy: tier ? { pts: 3240, tier: tier.id, next: next ? next.id : null, prog: 45, max: !next, rem: '550' } : null,
      addr: [{ a1: 'ul. Przykładowa 12', a2: '', zip: '00-001', city: 'Warszawa', name: 'Anna Przykładowa', co: '', def: true },
             { a1: 'ul. Przykładowa 5', a2: 'lok. 3', zip: '02-777', city: 'Warszawa', name: 'Biuro (przykład)', co: '', def: false }],
      count: 5, more: false,
      orders: [
        order({ n: '#D-1005', c: created(0), fs: false, ts: 'Paczkomat InPost', items: [it('ts'), it('fee')] }),
        order({ n: '#D-1004', c: created(-1), fs: true, m: 'delivery', d: day(nd), t: '12:00 - 15:00', adr: 'ul. Przykładowa 12, Warszawa', items: [it('rv'), it('cy')] }),
        order({ n: '#D-1003', c: created(-21), fs: true, m: 'pickup', d: day(addDays(TODAY, -19)), t: '13:00', loc: 'Batida Krakowskie Przedmieście', items: [it('mi'), it('du'), it('fr')] }),
        order({ n: '#D-1002', c: created(-70), fs: true, m: 'delivery', d: day(addDays(TODAY, -68)), t: '10:00 - 12:00', adr: 'ul. Przykładowa 12, Warszawa', items: [it('ow'), it('li'), it('na')] }),
        order({ n: '#D-1001', c: created(-120), cx: true, m: 'pickup', d: day(addDays(TODAY, -118)), t: '11:00', loc: 'Batida Giełdowa Wola', items: [it('mi', 1)] })
      ]
    };
  }
  function demoConnect() {
    var occ = list('dates_suggest');
    var soon = addDays(TODAY, 10), ann = nextOcc('12-28');
    return { ok: true, enabled: true,
      profile: { defaultLocationId: null, invoice: { always: true, nips: [{ nip: '0000000000', name: 'Firma Przykładowa sp. z o.o.', street: 'ul. Przykładowa 1', zip: '00-001', city: 'Warszawa' }] } },
      dates: [{ id: 'o1', date: soon.slice(5), next: soon, remindOn: addDays(soon, -7), label: occ[0] || '', person: raw('demo_person'), source: 'cart', orderName: '#D-1002' },
              { id: 'd2', date: '12-28', next: ann, remindOn: addDays(ann, -7), label: occ[2] || '', person: '', source: 'own' }],
      newsletter: { subscribed: false, canChange: true }, locations: [],
      features: { birthday: true },
      /* 14.10 "Twoje daty w kalendarzu": the block's switch as Connect reports it (konto.ics); review mode only */
      ics: { enabled: true, subscribe: true, csv: true, hasLink: false, downloadUrl: '/apps/connect/konto/dates.ics', csvUrl: '/apps/connect/konto/dates.csv' },
      rewards: [{ code: 'PRZYKLAD-10', percent: 10, validUntil: addDays(TODAY, 25), source: 'quiz', used: false }] };
  }

  /* =====================================================================================================================
     START
     ===================================================================================================================== */
  /* =====================================================================================================================
     PHASE 2 FEATURES (29.09 evening): each one is its own section + asset (sections/batida-konto-*.liquid,
     assets/batida-konto-*.js) and registers here with (window.BatidaKontoQ = window.BatidaKontoQ || []).push({id, render}).
     render(ctx) runs after every redraw of the panel and fills its slot(s): data-v7k-slot = hero | start-top | start |
     daty | faktury | ustawienia (display: contents inside the grids). A feature that throws is skipped; phase 1 keeps working.
     ===================================================================================================================== */
  var FEAT = [], CTX = null;
  function runFeatures() {
    if (!CTX) return;
    FEAT.forEach(function (f) { try { f.render(CTX); } catch (e) { if (window.console) console.error('[batida-konto] ' + f.id, e); } });
  }
  function makeCtx() {
    var c = {
      root: root, app: app, D: D, T: T, DEMO: DEMO, LANG: LANG, LOCALE: LOCALE, TODAY: TODAY, ORDERS: ORDERS, UPCOMING: UPCOMING, NEXT: NEXT,
      CONNECT_API: (window.BatidaConnect && window.BatidaConnect.api) || CONNECT,
      slot: function (name, id) {
        var s = $('[data-v7k-slot="' + name + '"]'); if (!s) return null;
        var el = s.querySelector('[data-v7k-f="' + id + '"]');
        if (!el) { el = document.createElement('div'); el.className = 'v7k-slot'; el.setAttribute('data-v7k-f', id); s.appendChild(el); }
        return el;
      },
      h: { esc: esc, money: money, num: num, dm: dm, dmy: dmy, dayLabel: dayLabel, whenLabel: whenLabel, normYmd: normYmd, addDays: addDays,
        diffDays: diffDays, dow: dow, wParts: wParts, wInstant: wInstant, shortName: shortName, icon: icon, toast: toast, blocked: blocked,
        box: box, errText: errText, nearest: nearest, selectTab: selectTab, connectApi: connectApi, saveProfile: saveProfile,
        rerender: renderAll, sget: sget, sset: sset }
    };
    Object.defineProperty(c, 'connect', { get: function () { return S.connect; } });
    return c;
  }
  var queued = window.BatidaKontoQ;
  window.BatidaKontoQ = { push: function (f) { if (!f || typeof f.render !== 'function') return; FEAT.push(f); runFeatures(); } };

  try {
    shell();
    CTX = makeCtx();
    (Array.isArray(queued) ? queued : []).forEach(function (f) { if (f && typeof f.render === 'function') FEAT.push(f); });
    renderAll();
    loadSlots();
    loadConnect().then(function (c) { S.connect = c; cacheProfile(); renderAll(); });
    loadConnectLoyalty().then(function (changed) { if (changed) renderAll(); });
  } catch (err) {
    if (window.console) console.error('[batida-konto]', err);
    app.hidden = true; var g = document.querySelector('[data-v7k-guest]'); if (g) g.hidden = false;
  }
})();
